import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Account } from 'src/api/@generated/backend-api';

import { AccountState } from './types';

const initialState: AccountState = {};

const accountSlice = createSlice({
  name: 'account',
  initialState,
  reducers: {
    setAccount: (state, action: PayloadAction<Account>) => {
      state.selectedAccount = action.payload;
    },
    resetAccount: (state) => {
      state.selectedAccount = undefined;
    },
  },
});

export const {
  actions: { setAccount, resetAccount },
  reducer: accountSliceReducer,
} = accountSlice;
